import request from '@/axios'
import type { UserType, UserLoginType, CaptchaType } from './types'

interface RoleParams {
  roleName: string
}

export const loginApi = (data: UserType): Promise<IResponse<UserLoginType>> => {
  return request.post({ url: '/web/auth/login', data })
}

// 获取验证码
export const fetchCaptcha = (): Promise<IResponse<CaptchaType>> => {
  return request.post({ url: '/web/auth/captcha' })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/web/auth/logout' })
}

// 获取公钥
export const getPublicKeyApi = (): Promise<IResponse<string>> => {
  return request.get({ url: '/web/auth/keypair' })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list', params })
}
